import React, { useState, useMemo, useContext } from "react";
import { 
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button,
    Typography,
    IconButton,
    Tooltip
} from "@material-ui/core";
import {
    AddCircle,
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { AppContext } from '../../context/AppContext';

export const AllUsersDialog = ({ open, toggle, org, users, reload }) => {
    const [error, setError] = useState('');
    const appCtx = useContext(AppContext);

    const _toggle = () => {
        toggle();
    };

    const addUserToOrg = async (user) => {
        console.log(`add user to org: `, user);
        let userData = user;
        const userOrganizations = (userData.organizations ?? []).map(o => ({ id: o.id }));
        userOrganizations.push({ id: org.id });
        userData.organizations = userOrganizations;

        await axios.patch('users', userData).then(result => {
            if (result.data && result.data.response === true) {
                reload();
                _toggle();

                appCtx.setAlert({ type: 'success', message: 'Add User To Organization' });
            } else {
                appCtx.setAlert({ type: 'error', message: 'Failed to add user to organization' });
            }
        }).catch(e => {
            appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to add user to organization' });
        });
    }

    const orgUsers = useMemo(() => {
        if (org) {
            return (users ?? []).filter(u => !u.organizations || u.organizations.length <= 0 || (u.organizations && !u.organizations.find(o => o.organization_id === org.id)));
        }
        return [];
    }, [users, org]);
    const tableData = useMemo(() => {
        return (orgUsers ?? []).map(u => [
            u.id, 
            u.email, 
            u.name, 
            <React.Fragment>
                <Tooltip title="Add User to Organization">
                    <IconButton>
                        <AddCircle />
                    </IconButton>
                </Tooltip>
            </React.Fragment>
        ]);
    }, [orgUsers]);

    return (
        <>
            <Dialog open={open} onClose={_toggle} maxWidth="lg" fullWidth>
                <DialogTitle>All Users</DialogTitle>
                <DialogContent>
                    <Grid container spacing={4} direction="column">
                        {error && error != '' && (
                            <Grid item>
                                <Typography variant="body1" style={{ color: 'red' }}>{error}</Typography>
                            </Grid>
                        )}
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                <MUIDataTable
                                    title={``}
                                    data={tableData ?? []}
                                    columns={["Id", "Email", "Name", ""]}
                                    options={{
                                        download: false,
                                        print: false,
                                        filter: false,
                                        search: true,
                                        searchOpen: true,
                                        searchPlaceholder: "Search users...",
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        onRowClick: (rowData, rowMeta) => {
                                            if (rowData) {
                                                addUserToOrg(orgUsers.find(u => u.id == rowData[0]));
                                            }
                                        }
                                    }}
                                />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2} direction="row">
                                <Grid item>
                                    <Button onClick={_toggle} variant="text" color="secondary">Cancel</Button>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};
export default AllUsersDialog;